import { nanoid } from 'nanoid';

// HEAD DATA
export const headData = {
  title: '', // e.g: 'Name | Developer'
  lang: '', // e.g: en, es, fr, jp
  description: '', // e.g: Welcome to my website
};

// HERO DATA
export const heroData = {
  title: '',
  name: '',
  subtitle: '',
  cta: '',
};

// ABOUT DATA
export const aboutData = {
  img: 'hungary-abasar-map.jpg',
  paragraphOne: '',
  paragraphTwo: '',
  paragraphThree: '',
  resume: 'https://www.resumemaker.online/es.php', // if no resume, the button will not show up
};

// FACTS DATA
export const factsData = {
  img: 'facts_lanchid.jpg',
  paragraphOne: '',
  paragraphTwo: '',
  paragraphThree: '',
  resume: 'https://www.resumemaker.online/es.php', // if no resume, the button will not show up
};

// FEATURES DATA
export const featuresData = {
  img: 'features_maps.jpg',
  paragraphOne: '',
  paragraphTwo: '',
  paragraphThree: '',
  resume: 'https://www.resumemaker.online/es.php', // if no resume, the button will not show up
};

// GALLERY DATA
export const galleryData = [
  {
    id: nanoid(),
    img: 'budapest-2030015_1920.jpg',
    title: 'Hungary',
  },
  {
    id: nanoid(),
    img: 'budapest-2043113_1920.jpg',
    title: 'Hungary',
  },
  {
    id: nanoid(),
    img: 'chain-bridge-3528259_1920.jpg',
    title: 'Hungary',
  },
  {
    id: nanoid(),
    img: 'lake-balaton-1608516_1920.jpg',
    title: 'Hungary',
  },
  {
    id: nanoid(),
    img: 'puszta-horse-farm-2443642_1920.jpg',
    title: 'Hungary',
  },
  {
    id: nanoid(),
    img: 'road-2875263_1920.jpg',
    title: 'Hungary',
  },
  {
    id: nanoid(),
    img: 'sailing-boat-1604128_1920.jpg',
    title: 'Hungary',
  },
];

// CONTACT DATA
export const contactData = {
  cta: '',
  btn: '',
  email: '',
};

// COMPANIES DATA
export const companiesData = [
  {
    id: nanoid(),
    img: 'audi.jpg',
    title: 'Audi',
  },
  {
    id: nanoid(),
    img: 'bmw.jpg',
    title: 'BMW',
  },
  {
    id: nanoid(),
    img: 'bosh.jpg',
    title: 'Bosh',
  },
  {
    id: nanoid(),
    img: 'continental.jpg',
    title: 'Continental',
  },
  {
    id: nanoid(),
    img: 'denso.jpg',
    title: 'Denso',
  },
  {
    id: nanoid(),
    img: 'doosan.jpg',
    title: 'Doosan',
  },
  {
    id: nanoid(),
    img: 'electrolux.jpg',
    title: 'Electrolux',
  },
  {
    id: nanoid(),
    img: 'flextronics.jpg',
    title: 'Flextronics',
  },
  {
    id: nanoid(),
    img: 'grundfos.jpg',
    title: 'Grundfos',
  },
  {
    id: nanoid(),
    img: 'hankook.jpg',
    title: 'Hankook',
  },
  {
    id: nanoid(),
    img: 'lear.jpg',
    title: 'Lear',
  },
  {
    id: nanoid(),
    img: 'mercedes.jpg',
    title: 'Mercedes',
  },
  {
    id: nanoid(),
    img: 'opel.jpg',
    title: 'Opel',
  },
  {
    id: nanoid(),
    img: 'samsung.jpg',
    title: 'Samsung',
  },
  {
    id: nanoid(),
    img: 'sanofi.jpg',
    title: 'Sanofi',
  },
  {
    id: nanoid(),
    img: 'suzuki.jpg',
    title: 'Suzuki',
  },
  {
    id: nanoid(),
    img: 'teva.jpg',
    title: 'Teva',
  },
  {
    id: nanoid(),
    img: 'valeo.jpg',
    title: 'Valeo',
  },
  {
    id: nanoid(),
    img: 'vizz.jpg',
    title: 'Vizz',
  },
];


// FOOTER DATA
export const footerData = {
  networks: [
    {
      id: nanoid(),
      name: 'twitter',
      url: '',
    },
    {
      id: nanoid(),
      name: 'codepen',
      url: '',
    },
    {
      id: nanoid(),
      name: 'linkedin',
      url: '',
    },
    {
      id: nanoid(),
      name: 'github',
      url: '',
    },
  ],
};

// Github start/fork buttons
export const githubButtons = {
  isEnabled: true, // set to false to disable the GitHub stars/fork buttons
};
